import React from "react";
import "../css/redes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Redes = () => {
  return (
    <body>
      <div className="sticky-container">
        <ul className="sticky">
          <li>
            <img
              src="https://play-lh.googleusercontent.com/bYtqbOcTYOlgc6gqZ2rwb8lptHuwlNE75zYJu6Bn076-hTmvd96HH-6v7S0YUAAJXoJN"
              width="32"
              height="32"
            ></img>
            <p>
              <a href="https://wa.link/0zbip1" target="_blank">
                Whatsapp
              </a>
            </p>
          </li>
          <li>
            <img
              src="https://www.facebook.com/images/fb_icon_325x325.png"
              width="32"
              height="32"
            ></img>
            <p>
              <a
                href="https://www.facebook.com/AmbitoInmobiliariaTuc"
                target="_blank"
              >
                Facebook
              </a>
            </p>
          </li>
          <li>
            <img
              src="data:image/png;base64,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"
              width="32"
              height="32"
            ></img>
            <p>
              <a
                href="https://www.youtube.com/channel/UCmTISs1LYEL-k8x36VxmZwg"
                target="_blank"
              >
                Youtube
              </a>
            </p>
          </li>

          <li>
            <img
              src="https://www.edigitalagency.com.au/wp-content/uploads/Instagram-logo-gif-dot-flashing.gif"
              width="32"
              height="32"
            ></img>
            <p>
              <a
                href="https://instagram.com/ambitoinmobiliariatuc?utm_medium=copy_link"
                target="_blank"
              >
                Instagram
              </a>
            </p>
          </li>
        </ul>
      </div>
    </body>
  );
};

export default Redes;
